export enum SortingKey {
    DAYS_LEFT_SAILING = 'DAYS_LEFT_SAILING',
    NEXT_KEY_PORT = 'NEXT_KEY_PORT',
}
